<template>
  <div>
    <pool-add-modal ref="poolAdd" :customer-id="customerId" :show.sync="showModal" />

    <loading v-model="loading" :height="300">
      <div class="table-fix-head table-height-300">
        <table class="table table-light">
          <thead>
            <tr>
              <th scope="col" class="p-2">
                Felhasználható ettől
              </th>
              <th scope="col" class="p-2">
                Felhasználható eddig
              </th>
              <th scope="col" class="p-2">
                Vásárlás
              </th>
              <th scope="col" class="p-2">
                Keret
              </th>
              <th scope="col" class="p-2 text-right">
                Műveletek
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(pool, index) in pools"
              :key="`po${index}`"
              :class="dateClass(pool)"
            >
              <td class="p-2">{{ displayFormatDate(pool.validity_start) }}</td>
              <td class="p-2">{{ displayFormatDate(pool.validity_end) }}</td>
              <td class="p-2" v-if="pool.purchase !== null">
                <span class="badge badge-secondary mr-1">#{{ pool.purchase.id }}</span>
                {{ displayFormatDate(pool.purchase.created_at) }}
              </td>
              <td class="p-2" v-if="pool.purchase === null">Törölt vásárlás</td>
              <td class="p-2">
                <pool-limitations :limitations="pool.limitations" />
              </td>
              <td class="p-2 text-right">
                <b-button-group size="sm">
                  <b-button variant="danger" size="sm" @click="deletePool(pool, index)">
                    Törlés
                  </b-button>
                </b-button-group>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </loading>
  </div>
</template>
<style lang="scss">
</style>
<script>
import PoolAddModal from '../pools/PoolAddModal'
import moment from 'moment'
import Loading from '../common/LoadingPlaceholder'
import PoolLimitations from './partials/PoolLimitations'

import { displayFormatDate } from '../../utils/Date'
import TableHelper from '../../utils/mixins/TableHelper'

export default {
  mixins: [
    TableHelper('pools', 'id', {
      customerId: {
        type: Number,
        required: true,
        default: -1
      }
    }, 'api.billing-pools.index')
  ],
  components: {
    'pool-limitations': PoolLimitations,
    'pool-add-modal': PoolAddModal,
    'loading': Loading
  },
  data() {
    return {
      showModal: false,
      loading: true,
      pools: [],
    }
  },
  mounted() {
    this.$root.$on('purchase', this.poolPurchased.bind(this))
    this.$root.$on('add-pool', this.poolPurchased.bind(this))
  },
  methods: {
    poolPurchased({pool, purchase = null}) {
      this.pools.push({
        ...pool,
        purchase: purchase
      })
    },
    deletePool(pool, index) {
      this.$bvModal.msgBoxConfirm(`Biztosan törölni szeretnéd ezt a készletet?`, {
      title: 'Megerősítés',
      okVariant: 'danger',
      okTitle: 'Igen',
      cancelTitle: 'Mégsem'
    }).then(value => {
      if(value) {
        this.$http.delete(this.$url('api.billing-pools.destroy', pool.id))
          .then(() => {
            this.pools.splice(index, 1)
          })
          .catch(() => {
            this.$bvToast.toast('Hiba történt a művelet végrehajtása közben!', {
              title: 'Hiba',
              variant: 'danger'
            })
          })
      }
    })
    },
    dateClass({validity_start, validity_end}) {
      var from = moment(validity_start, moment.ISO_8601),
        to = moment(validity_end, moment.ISO_8601)

      var active = (to.isValid() && moment().isBetween(from, to, undefined, '[]')) ||
        moment().isSameOrAfter(from)

      if(active) {
        return ['text-success', 'font-bold']
      } else {
        return ''
      }
    },
    displayFormatDate
  }
}
</script>